import React from 'react';

const Checkbox = ({
    name,
    checked,
    onChange,
    label,
    className = "",
    disabled=false
}) => {
    return (
        <div className={`${className}`}>
            <div className="form-check">
                <input
                    type="checkbox"
                    className={`h-4 w-4 form-check-input`}
                    id={name}
                    disabled={disabled}
                    checked={checked}
                    onChange={onChange}
                />
                {label && (
                    <label
                        className='form-check-label text-grey'
                        htmlFor={name}
                    >
                        {label}
                    </label>
                )}
            </div>
        </div>
    );
};

export default Checkbox;
